//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';

//  -- Actions ------------------------
import * as ebookHighLightsAction from './actions';
import { logToSentry } from "utils/networkErrorUtils";

//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------

//  -- Create log ----------------


export const handleCreateEbookHighlights = (data) => async dispatch =>{
	try {
		const highlights = await apis.post('ebook_highlight', `/create_highlight`, {
			body: { ...data }
		});
		if (highlights && highlights.id) {
			dispatch(ebookHighLightsAction.createOrUpdateEbookHighlight(highlights))
		}
		return highlights;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'creating ebook highlights',
                error,
                module: 'EBOOK_HIGHLIGHTER',
                operation: 'CREATE_EBOOK_HIGHLIGHTER'
            });
		}
		return [];
	}
};
export const handleListUserEbooklights =  (user_id,book_id,class_id) => async dispatch =>{
	dispatch(ebookHighLightsAction.clearEbookHighlighter());
	try {
		const highlights = await apis.post('ebook_highlight', `/list_ebook_highlights`, {
			body: { user_id, book_id,class_id }
		});
		if (Array.isArray(highlights)) {
			dispatch(ebookHighLightsAction.setEbookHighlight(highlights))
		}
		return highlights;
	} catch (error) {
		if (error && error.message != "Network Error") {
			logToSentry({
                message: 'listing user ebook highlights',
                error,
                module: 'EBOOK_HIGHLIGHTER',
                operation: 'LIST_USER_EBOOK_HIGHLIGHTER'
            });
		}
		return error;
	}
};
